import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        name: 'calculated',
        url: '/calculated/:identifierGuid/:beginDate/:endDate',
        component: 'wtCalculatedContainerState',
        abstract: true,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            dates: Resolve.datesResolve
        },
        params: {
            beginDate: '',
            endDate: ''
        },
        data: {
            displayName: 'Identifiers',
            isAuthenticated: true,
            isConnected: true,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'identifiers',
                level4: ''
            }
        }
    },
    {
        name: 'calculated.shewhart',
        url: '/shewhart',
        template: '<wt-calculated-shewhart-state class="flex-fill"></wt-calculated-shewhart-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve
        },
        data: {
            displayName: 'Shewhart',
            icon: 'fa-stethoscope',
            isAuthenticated: true,
            isConnected: true,
            sortingOrder: 2,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Identifier',
                level4: '',
                level5: 'Shewhart'
            }
        }
    },
    {
        name: 'calculated.analysis',
        url: '/analysis',
        template: '<wt-calculated-analysis-state class="flex-fill"></wt-calculated-analysis-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve
        },
        data: {
            displayName: 'Analysis',
            icon: 'fa-area-chart',
            sortingOrder: 1,
            isAuthenticated: true,
            isConnected: true,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Identifier',
                level4: '',
                level5: 'Analysis'
            }
        }
    },
    {
        name: 'calculated.general',
        url: '/general',
        template: '<wt-calculated-general-state class="flex-fill" identifier-vm="vm.identifierVm"></wt-calculated-general-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
        },
        data: {
            displayName: 'Identifiers',
            icon: 'fa-line-chart',
            isAuthenticated: true,
            isConnected: true,
            sortingOrder: 0,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Identifier',
                level4: '',
                level5: 'General'
            }
        }
    }
];

export default states;